import { Component, Input, OnDestroy, OnInit, ViewChild, isDevMode } from '@angular/core';
import { IonicModule, IonMenu, ModalController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/core/services/auth.service';
import { BusinessesService } from 'src/app/core/services/businesses.service';
import { LocationsService } from 'src/app/core/services/locations.service';
import { AboutComponent } from '../about/about.component';
import { MenuController } from '@ionic/angular/standalone';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { addIcons } from 'ionicons';
import { restaurantOutline, documentTextOutline, timeOutline, earth, chatboxEllipsesOutline, informationCircleOutline, logOutOutline } from 'ionicons/icons';
import { MenuEditorService } from '../../services/menueditor.service';

@Component({
    selector: 'app-mainmenu',
    templateUrl: './mainmenu.component.html',
    styleUrls: ['./mainmenu.component.scss'],
    imports: [IonicModule, TranslateModule, RouterModule]
})

export class MainmenuComponent  implements OnInit, OnDestroy {

  @Input() enableSidebarMenu: boolean = false;

  public business: any = null;
  
  private subscription!: Subscription;

  public noBusinessImageUrl: string = '../../../assets/icon/no-image.png';

  constructor(private authService: AuthService,
              private businessesService: BusinessesService,
              private locationsService: LocationsService,
              private modalController: ModalController,
              private menuController: MenuController,
              private translate: TranslateService,
              private menuEditorSrv: MenuEditorService
  ) { 
    addIcons({ restaurantOutline, documentTextOutline, timeOutline, earth, chatboxEllipsesOutline, informationCircleOutline, logOutOutline });
  }

  ngOnInit() {
    this.subscription = this.businessesService.getBusinessActive().subscribe((business) => {
      this.business = business;
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public logout(): void {
    this.businessesService.reset();
    this.locationsService.reset();
    this.menuEditorSrv.reset();
    this.authService.logOut();
  }

  public about(): void {
    this.modalController.create({
      component: AboutComponent
    }).then(modalElement => {
          modalElement.present();
          return modalElement.onDidDismiss();
    });
  }

  public isUserLoggedIn(): boolean {
    return this.authService.authToken ? true : false;
  }

  public getLogoUrl(): string {
    return this.business.logoUrl !== "" ? this.business.logoUrl : this.noBusinessImageUrl;
  }

  public handleClick(): void {
    if(this.enableSidebarMenu) {
      this.menuController.close();
    }
  }

  public switchLanguage() {
    if (this.translate.currentLang === 'es') {
      this.translate.use('en');
    } else {
      this.translate.use('es');
    }
  }

  isDev(): boolean {
    return isDevMode();
  }

}
